import React from 'react' 

const Projects = () => {
    return (
        <div className="container">
            <br/>
            <br/>
            <br/>
            <br/>

            <h1 className="center">Projects 💼</h1>
            <br/>
            <div class="allprojects-columns">
            <div class="project-column-right">
                <br/>
            <img className = "projects-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%2063%20(1).png"></img>
            </div>
            <div class="project-column-left">
            <h2>Bitly API Explorer 🔗</h2>
            <p className ="projects-p-i"><i>Software Engineering Internship, Bitly</i></p>
            <p className ="projects-p">Designed and developed an easier space for users to interact with HTTP Request Methods from the Bitly API.</p>
            <a
                className="general-button"
                href="https://github.com/bitly/sprinterns2022"
                rel="noopener noreferrer"
            >
                Learn more!
            </a>
            </div>
            </div>

            <br/>

            <div class="allprojects-columns">
            <div class="project-column-right">
                <br/>
            <img className = "projects-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%2064%20(1).png"></img>
            </div>
            <div class="project-column-left">
            <h2>Unicorn Stack 🦄</h2>
            <p className ="projects-p-i"><i>Overall Winner, QImpacts! Hackathon</i></p>
            <p className ="projects-p">Developed a gamified platform to increase financial literacy through AR, 3D experiences, budget tracking.</p>
            <a
                className="general-button"
                href="https://github.com/skylerbasco/Unicorn-Stack"
                rel="noopener noreferrer"
            >
                Learn more!
            </a>
            </div>
            </div>

            <br/>

            <div class="allprojects-columns">
            <div class="project-column-right">
                <br/>
            <img className = "projects-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%2061%20(1).png"></img>
            </div>
            <div class="project-column-left">
            <h2>Melodies for Math 🧮</h2>
            <p className ="projects-p-i"><i>Web Developer, Nonprofit Volunteering</i></p>
            <p className ="projects-p">Developed a gamified platform to increase financial literacy through AR, 3D experiences, budget tracking.</p>
            <a
                className="general-button"
                href="https://github.com/skylerbasco/Melodies-for-Math-Website"
                rel="noopener noreferrer"
            >
                Learn more!
            </a>
            </div>
            </div>

            <br/>

            <div class="allprojects-columns">
            <div class="project-column-right">
                <br/>
            <img className = "projects-pic" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%2062.png"></img>
            </div>
            <div class="project-column-left">
            <h2>Learnify 📓</h2>
            <p className ="projects-p-i"><i>2nd Place, Girls Who Code Hackathon</i></p>
            <p className ="projects-p">Developed a gamified platform to increase financial literacy through AR, 3D experiences, budget tracking.</p>
            <a
                className="general-button"
                href="https://github.com/skylerbasco/Learnify"
                rel="noopener noreferrer"
            >
                Learn more!
            </a>
            </div>
            </div>
            <br/>
        </div>
    )
}

export default Projects
